<template lang="html">
<div>
  <section class="login">
    <div class="row w-100" >
                           <div class="col-lg-6 mx-auto" style="padding-top:150px;">
                              <video width="100%" height="500" controls>
  <source src="../../assets/videonew.mp4" type="video/mp4" >
Your browser does not support the video tag.
</video>
                             </div>
                          </div>
  </section>
        
</div>
</template>

<script>
import axios from 'axios'
import store from '../../store'
export default {
  name: 'login',
  data () {
    return {
    }
  },

}
</script>

<style>
.main-panel {
  width: calc(100% - 0px);
  min-height: calc(100vh - 58px);
}
body {
  background-color: #f6f8fa;
}
</style>



// WEBPACK FOOTER //
// src/views/sample-pages/register.vue